import {BehaviorSubject} from 'rxjs';
import {filter, map} from 'rxjs/operators';
import {wsOpened$} from './ws';
import {wwData$} from './worker-data';
import {divided} from '@px/helper';

export const indexPricesCache$ = new BehaviorSubject(new Map());

wsOpened$.subscribe(() => indexPricesCache$.next(new Map()));

wwData$
  .pipe(
    filter((o) => o.type === 'index-price'),
    map((o) => o.data.prices as PricesCache)
  )
  .subscribe((o) => indexPricesCache$.next(o));

export function getCurrencyIndexPrice(cache: PricesCache, currency: string): PriceEntity {
  const key = '.' + currency;
  if (cache.has(key)) {
    return cache.get(key);
  }
  return null;
}

export function getCurrencyIndexPriceEp(cache: PricesCache, currency: string): number {
  const price = getCurrencyIndexPrice(cache, currency);
  console.log(price);
  if (price) {
    return price.priceEp;
  }
  return null;
}

export function getCurrencyIndexPriceRp(cache: PricesCache, currency: string): string {
  const price = getCurrencyIndexPrice(cache, currency);
  if (price) {
    return divided(price.priceEp, price.priceFactor);
  }
  return null;
}
